/* eslint-disable quotes */
import React, {
	FunctionComponent,
	ReactNode,
	useCallback,
	useEffect,
	useMemo,
	useState,
} from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { HeaderType } from "../types/HeaderType";
import useLang from "../hooks/useLang";
import api from "../utils/axios";
import { ProfileType } from "../types/ProfileType";
import "./Header.css";
import { ReactComponent as PostmanLogo } from "../assets/logo-light-full.svg";
import { ReactComponent as PostmanLogoClient } from "../assets/PostmanLogo2.svg";
import { ReactComponent as SearchIcon } from "../assets/search-find.svg";
import { ReactComponent as NotificationLogo } from "../assets/notification-alert.svg";
import { ReactComponent as ProfileLogo } from "../assets/profile.svg";
import { ReactComponent as ProfileLogoBlue } from "../assets/profile-blue.svg";
import { ReactComponent as ArrowProfile } from "../assets/chevron-line-down.svg";
import { ReactComponent as ArrowProfileBlue } from "../assets/chevrovDown.svg";
import { ReactComponent as ChartLine } from "../assets/chart-line.svg";
import { ReactComponent as ChartLineBlue } from "../assets/chart-line-blue.svg";
import { ReactComponent as MenuList } from "../assets/menu-list.svg";
import { ReactComponent as MenuListGray } from "../assets/menu-list-gray.svg";
import { ReactComponent as FinanceLogo } from "../assets/payment-money-coins-alt.svg";
import { ReactComponent as FinanceLogoGray } from "../assets/payment-money-coins-alt-gray.svg";
import { ReactComponent as BookOpen } from "../assets/BookOpen.svg";
import { ReactComponent as BookOpenGray } from "../assets/BookOpenGray.svg";
import { ReactComponent as AccountIcon } from "../assets/AccountsIcon.svg";
import { ReactComponent as AccountIconGray } from "../assets/AccountIconGray.svg";
import { DatabaseOutlined } from "@ant-design/icons";
import { ReactComponent as PlusIcon } from "../assets/add-plus-circle-filled.svg";
import { ReactComponent as PlusIconWhite } from "../assets/add-plus-circle-filled-white.svg";
import { ReactComponent as AccountProfile } from "../assets/AccountProfile.svg";
import { ReactComponent as Notification } from "../assets/Notification.svg";
import { ReactComponent as ArrowLogout } from "../assets/arrow-logout.svg";
import { ReactComponent as MessagesIcon } from "../assets/Message.svg";
import { ReactComponent as BurgerMenu } from "../assets/burger-menu.svg";
import { ReactComponent as BurgerMenuGray } from "../assets/burger-menu-gray.svg";
import { ReactComponent as MessageWhiteIcon } from "../assets/MessageWhiteIcon.svg";
import { ReactComponent as MessageBlueIcon } from "../assets/Message-blue-Icon.svg";
import { ReactComponent as ArrangementIcon } from "../assets/Arrangement.svg";
import { ReactComponent as ArrangementIconGray } from "../assets/ArrangementGray.svg";
import { ReactComponent as KomunikimetIcon } from "../assets/komunikimetIcon.svg";
import { ReactComponent as KomunikimetIconBlue } from "../assets/komunikimetIconBlue.svg";
import { ReactComponent as BallinaDefaultIcon } from "../assets/BallinaDefaultIcon.svg";
import { ReactComponent as BallinaDefaultIconGray } from "../assets/BallinaDefaultIconGray.svg";
import { ReactComponent as OrderIcon } from "../assets/orderActiveIcon.svg";
import { ReactComponent as OrderIconBlue } from "../assets/OrderIconBlue.svg";
import { ReactComponent as FinanceActiveIcon } from "../assets/FinanceActiveIcon.svg";
import { ReactComponent as FinanceActiveIconBlue } from "../assets/FinanceActiveIconBlue.svg";
import { ReactComponent as SettlementActiveIcon } from "../assets/SettlementActiveIcon.svg";
import { ReactComponent as SettlementActiveIconBlue } from "../assets/SettlementActiveIconBlue.svg";
import { ReactComponent as ArrangmentsActiveIcon } from "../assets/ArrangmentsActiveIcon.svg";
import { ReactComponent as ArrangmentsActiveIconBlue } from "../assets/ArrangmentsActiveIconBlue.svg";
import { ReactComponent as KomunikimetActiveIcon } from "../assets/KomunikimetActiveIcon.svg";
import { ReactComponent as KomunikimetActiveIconGray } from "../assets/KomunikimetActiveIconGray.svg";
import { ReactComponent as LlogariteActiveIcon } from "../assets/account-profile-users-group.svg";
import { ReactComponent as LlogariteActiveIconBlue } from "../assets/account-profile-users-group-blue.svg";
import { ReactComponent as EuroKargo } from "../assets/LOGOA.svg";
import { ReactComponent as NotificationBlue } from "../assets/notification-blue.svg";
import { ReactComponent as SquareHeader } from "../assets/squaresIconWeb.svg";
// import { ReactComponent as PostmanLogo2 } from "../assets/PostmanLogo2.svg";
// import { ReactComponent as ProfileLogoLogin } from "../assets/account-profile-user-circle.svg";
import { Menu as MuiMenu, MenuItem, IconButton, Tooltip } from "@mui/material";
import {
	Badge,
	Button,
	Dropdown,
	Input,
	Menu,
	MenuProps,
	Modal,
	Radio,
} from "antd";
import { ReactComponent as EnglishFlag } from "../assets/UnitedStates-flagpalette.svg";
import { ReactComponent as AlbanianFlag } from "../assets/Albania-flagpalette.svg";
import { ReactComponent as MacedonianFlag } from "../assets/NorthMacedonia-flagpalette.svg";
import { ReactComponent as LangugagesIcon } from "../assets/language-svgrepo-com.svg";
import { ReactComponent as NotificationTruckIcon } from "../assets/NotificationTruck.svg";
import { ReactComponent as DeleteTrash } from "../assets/delete-trash-alt.svg";
import { setLanguage } from "../redux/langSlice";

import {
	Autocomplete,
	Collapse,
	Drawer,
	List,
	ListItemButton,
	ListItemIcon,
	ListItemText,
	TextField,
	useMediaQuery,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../redux/authSlice";
import { clearRequestCache } from "../utils/requestCache";
import {
	getUserMenuOptionsFromToken,
	getUserRoleFromToken,
} from "../utils/Auth";
import useAuth from "../hooks/useAuth";
import { MenuAccess } from "../utils/menuOptions";
import { canAccessBulkOrderOperations } from "../utils/bulkOperationsConfig";
import { toast } from "react-toastify";
import { Select } from "antd";
import { userRoles } from "../types/enums";
import { UserSearchBarType } from "../types/UserSearchBarType";
import { NotificationType } from "../types/NotificationType";
import { setReceivedNewNotification } from "../redux/notificationSlice";
import Buttons from "./form/Buttons";
import { getConfigurationValue } from "../lib/OptionListApi";
import { hasAccess } from "../lib/MenuValidation";
import { ReactComponent as SquareLoginLeft } from "../assets/squares-bg-left.svg";
import { ReactComponent as SquareLoginRight } from "../assets/squares-bg-right.svg";
import { setSkanoModalOpen } from "../redux/skanoModalSlice";
const { Option } = Select;

type SubMenu = {
	name: string;
	link: string;
	menuOption: MenuAccess;
};

type Menu = {
	name: string;
	menuOption?: MenuAccess;
	submenus?: SubMenu[];
	icon: FunctionComponent;
	activeIcon?: FunctionComponent;
	type?: "dropdown" | "button";
	link?: string;
	// Gated by the bulk-operations allowlist (role + per-country user id) instead
	// of a MenuOptions claim — see utils/bulkOperationsConfig.ts.
	adminOnly?: boolean;
};

const hexToRgba = (hex: string, alpha: number) => {
	const r = parseInt(hex.slice(1, 3), 16);
	const g = parseInt(hex.slice(3, 5), 16);
	const b = parseInt(hex.slice(5, 7), 16);
	return `rgba(${r},${g},${b},${alpha})`;
};

// "Erind Isufi" -> "EI": first letters of the first and last word.
const nameInitials = (name?: string | null) => {
	const words = (name ?? "").trim().split(/\s+/).filter(Boolean);
	if (!words.length) return "";
	const first = words[0][0];
	const last = words.length > 1 ? words[words.length - 1][0] : "";
	return `${first}${last}`.toUpperCase();
};

const Header = ({ loggedIn }: HeaderType) => {
	const rgbaColor = hexToRgba("#36B37E", 0.08);

	const [userData, setUserData] = useState<ProfileType | null>();
	const [userRole, setUserRole] = useState<any>();
	const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
	const [openOrders, setOpenOrders] = useState(false);
	const [openLlogarit, setOpenLlogarit] = useState(false);
	const [showTiketatModal, setShowTiketatModal] = useState(false);
	const [showSkanoModal, setShowSkanoModal] = useState(false);
	const [showDot, setShowDot] = useState<boolean>(false);
	const [openWareHouseManagerErrorModal, setOpenWareHouseManagerErrorModal] =
		useState<boolean>(false);
	const [windowWidth, setWindowWidth] = useState<number>(window.innerWidth);
	const location = useLocation();
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const [ticketOrderIds, setTicketOrderIds] = useState<string>();
	const [orderList, setOrderList] = useState<any[]>([]);
	const [searchValue, setSearchValue] = useState("");
	const [clients, setClients] = useState([]);
	const [drivers, setDrivers] = useState([]);
	const [staff, setStaff] = useState<any>([]);
	const [settlement, setSettlement] = useState([]);
	const [settlementRefusals, setSettlementRefusals] = useState([]);
	const [notifications, setNotifications] = useState<MenuProps["items"]>([]);
	const [isNotificationModalVisible, setIsNotificationModalVisible] =
		useState<boolean>(false);
	const [selectedNotification, setSelectedNotification] =
		useState<NotificationType | null>(null);
	const [showNotificationDot, setShowNotificationDot] =
		useState<boolean>(false);
	const [isPrintFormatModalOpen, setIsPrintFormatModalOpen] = useState(false);
	const [selectedPrintFormat, setSelectedPrintFormat] = useState("100x60");
	const [activePrintFunction, setActivePrintFunction] = useState<
		"tickets" | "orders" | null
	>(null);
	const [isClient, setIsClient] = useState<boolean>(false);

	const hasAccessToA4 = hasAccess("A4_TICKETS_ACCESS");
	const hasAccessToHarleyTickets = hasAccess("HARLEY_TICKETS_ACCESS");
	const hasAccessToAcceptLocalOrders = hasAccess("ORDER_ACCEPT_LOCAL_ACCESS");

	const userRoleId = getUserRoleFromToken();

	const isToggling = useSelector(
		(state: any) => state.message.receivedNewMessages
	);

	const isNotificationToggling = useSelector(
		(state: any) => state.notification.receivedNewNotification
	);
	const [warehouseErrorString, setWarehouseErrorString] = useState(
		"Error: Kjo porosi nuk mund te pranohet ne depo sepse nuk eshte ne Statuse e duhura: (Gati per grumbullim, Grumbulluar, Ne Depo"
	);
	const [menus, setMenus] = useState<Menu[]>([]);
	const { strings } = useLang("header");
	const { menuOptions, isLoggedIn } = useAuth();

	const onClick = useCallback(() => {
		// Log out here even when the API cannot be reached: the user asked to leave, and a failed
		// session refresh no longer logs them out on its own.
		api.post("user/logout")
			.catch(() => undefined)
			.then(() => {
				clearRequestCache();
				setUserData(null);
				setSearchValue("");
				setFilteredResults([]);
				dispatch(logout());
				localStorage.removeItem("token");
				navigate("/login");
			});
	}, [dispatch, navigate]);

	const getUserById = useCallback(async () => {
		try {
			// Background lookups: no full-screen loader on every page.
			const response = await api.get("User/userbyid", { silent: true });
			if (response.data && response.status === 200) {
				setUserData(response.data);
			} else {
				return false;
			}
		} catch (error) {
			console.log(error);
			return false;
		}
	}, []);

	const fetchNotificantions = async () => {
		try {
			const response = await api.get(
				"Notification/select-notifications",
				{
					silent: true,
				}
			);
			if (response.status === 200 && response.data) {
				if (response.data.length > 0) {
					const notificationResults = response?.data.map(
						(item: NotificationType) => ({
							label: item.title,
							key: item.id.toString(),
							icon: <NotificationTruckIcon />,
							disabled: item.opened,
							onClick: () => handleNotificationClick(item),
						})
					);

					const clearItem = {
						label: "Fshij njoftimet",
						key: "clear",
						icon: <DeleteTrash />,
						disabled: false,
						onClick: () => clearNotifications(), // Define the onClick handler
					};
					setNotifications([clearItem, ...notificationResults]);
				} else if (response.data.length === 0) {
					const noItems = [
						{
							label: "Nuk ka asnje njoftim",
							key: "nodata",
							icon: null,
							disabled: false,
						},
					];
					setNotifications(noItems);
				}
			}
		} catch (error) {
			console.log();
		}
	};

	const [configurationId, setConfigurationId] = useState<number | undefined>(
		undefined
	);

	const fetchConfiguration = async () => {
		const countryConfigurationValue = await getConfigurationValue(2);
		const countryValue = Number(countryConfigurationValue);
		setConfigurationId(countryValue);
	};

	useEffect(() => {
		if (isLoggedIn) {
			const userRoleId = getUserRoleFromToken();
			userRoleId === userRoles.CLIENT ||
			userRoleId === userRoles.SUBCLIENT
				? setIsClient(true)
				: setIsClient(false);
			getUserById();
		}

		const handleResize = () => {
			if (window.innerWidth > 1200) {
				setMobileMenuOpen(false);
			}
		};

		window.addEventListener("resize", handleResize);

		handleResize();
		// fetchDataFromRedis();
		fetchNotificantions();
		fetchConfiguration();
		return () => window.removeEventListener("resize", handleResize);
	}, [setUserData, isLoggedIn, getUserById]);

	useEffect(() => {
		dispatch(setSkanoModalOpen(showSkanoModal));
	}, [dispatch, showSkanoModal]);

	useEffect(() => {
		let interval: NodeJS.Timeout | null = null;
		if (isToggling) {
			interval = setInterval(() => {
				setShowDot((prevShowDot) => !prevShowDot);
			}, 1000);
		} else {
			setShowDot(false);
		}
		if (isNotificationToggling) {
			interval = setInterval(() => {
				setShowNotificationDot((prevShowDot) => !prevShowDot);
			}, 1000);
			fetchNotificantions();
		} else {
			setShowNotificationDot(false);
		}

		if (!strings) {
			return;
		}
		const menus: Menu[] = [
			{
				name: strings?.dashboard,
				link: "/dashboard",
				menuOption: "HOME_ACCESS",
				icon: isClient ? BallinaDefaultIconGray : BallinaDefaultIcon,
				activeIcon: isClient ? ChartLineBlue : ChartLine,
			},
			userRoleId === userRoles.RETURN_WAREHOUSEMANAGER
				? {
						name: strings?.order,
						link: "/return-storage-orders",
						menuOption: "RETURN_STORAGE_ORDERS_ACCESS",
						submenus: [
							{
								name: strings?.registererdOrders,
								link: "/registered-orders",
								menuOption: "REGISTERED_ORDERS_ACCESS",
							},
							{
								name: strings?.forCollection,
								link: "/waiting-pickup-orders",
								menuOption: "WAITING_PICKUP_ORDERS_ACCESS",
							},
							{
								name: strings?.redirectedOrders,
								link: "/redirected-orders",
								menuOption: "REDIRECTED_ORDERS_ACCESS",
							},
							// {
							// 	name: "Te gjitha",
							// 	link: "/order",
							// 	menuOption: "ORDERS_ACCESS",
							// },
						],
						icon: isClient ? MenuListGray : MenuList,
						activeIcon: isClient ? OrderIconBlue : OrderIcon,
						type: "dropdown",
				  }
				: {
						name: strings?.order,
						link: "/order",
						menuOption: "ORDERS_ACCESS",
						submenus: [
							{
								name: strings?.registererdOrders,
								link: "/registered-orders",
								menuOption: "REGISTERED_ORDERS_ACCESS",
							},
							{
								name: strings?.dashboardOrders,
								link: "/dashboard-orders",
								menuOption: "MOCK_ORDERS_ACCESS",
							},
							{
								name: strings?.forCollection,
								link: "/waiting-pickup-orders",
								menuOption: "WAITING_PICKUP_ORDERS_ACCESS",
							},
							{
								name: strings?.redirectedOrders,
								link: "/redirected-orders",
								menuOption: "REDIRECTED_ORDERS_ACCESS",
							},
							{
								name: "Porosite e barazuara",
								link: "/settled-orders",
								menuOption: "SETTLED_ORDERS_ACCESS",
							},
							// {
							// 	name: "Te gjitha",
							// 	link: "/order",
							// 	menuOption: "ORDERS_ACCESS",
							// },
							{
								name: strings?.returnStorageOrders,
								link: "/return-storage-orders",
								menuOption: "RETURN_STORAGE_ORDERS_ACCESS",
							},
							{
								name: strings?.newBuyers,
								link: "/unlinked-buyer",
								menuOption: "UNLINKED_BUYERS_ACCESS",
							},
						],
						icon: isClient ? MenuListGray : MenuList,
						activeIcon: isClient ? OrderIconBlue : OrderIcon,
						type: "dropdown",
				  },
			{
				name: strings?.finance,
				link: "/admin-finance",
				icon: isClient ? FinanceLogoGray : FinanceLogo,
				activeIcon: isClient
					? FinanceActiveIconBlue
					: FinanceActiveIcon,
				menuOption: "ADMIN_FINANCES_ACCESS",
			},
			{
				name: strings?.finance,
				link: "/finance",
				icon: isClient ? FinanceLogoGray : FinanceLogo,
				activeIcon: isClient
					? FinanceActiveIconBlue
					: FinanceActiveIcon,
				menuOption: "FINANCES_ACCESS",
			},
			{
				name: strings?.settlement,
				link: "/settlement",
				icon: isClient ? BookOpenGray : BookOpen,
				activeIcon: isClient
					? SettlementActiveIconBlue
					: SettlementActiveIcon,
				menuOption: "SETTLEMENTS_ACCESS",
			},
			{
				name: strings?.refusals,
				link: "/refusals",
				icon: isClient ? BookOpenGray : BookOpen,
				activeIcon: isClient
					? SettlementActiveIconBlue
					: SettlementActiveIcon,
				menuOption: "REFUSALS_ACCESS",
			},
			{
				name: strings?.arrangments,
				link: "/arrangments",
				icon: isClient ? ArrangementIconGray : ArrangementIcon,
				activeIcon: isClient
					? ArrangmentsActiveIconBlue
					: ArrangmentsActiveIcon,
				menuOption: "ARRANGEMENTS_ACCESS",
			},
			{
				name: strings?.refunds,
				link: "/refunds",
				icon: isClient ? ArrangementIconGray : ArrangementIcon,
				activeIcon: isClient
					? ArrangmentsActiveIconBlue
					: ArrangmentsActiveIcon,
				menuOption: "REFUNDS_ACCESS",
			},
			{
				name: strings?.communication,
				link: "/messages",
				icon: isClient
					? KomunikimetActiveIconGray
					: KomunikimetActiveIcon,
				activeIcon: isClient ? KomunikimetIconBlue : KomunikimetIcon,
				menuOption: "MESSAGES_ACCESS",
			},
			{
				name: strings?.accounts,
				icon: isClient ? AccountIconGray : AccountIcon,
				activeIcon: isClient
					? LlogariteActiveIconBlue
					: LlogariteActiveIcon,
				submenus: [
					{
						name: strings?.clients,
						link: "/clients",
						menuOption: "CLIENTS_ACCESS",
					},
					{
						name: strings?.drivers,
						link: "/drivers",
						menuOption: "DRIVERS_ACCESS",
					},
					{
						name: strings?.staffAccounts,
						link: "/staff-accounts",
						menuOption: "STAFF_ACCOUNTS_ACCESS",
					},
					{
						name: strings?.blockedAccounts,
						link: "/blocked-accounts",
						menuOption: "BLOCKED_ACCOUNTS_ACCESS",
					},
					{
						name: strings?.passiveAccounts,
						link: "/passive-client-accounts",
						menuOption: "PASSIVE_CLIENT_ACCOUNTS_ACCESS",
					},
					{
						name: strings?.accountsApproval,
						link: "/unapproved-accounts",
						menuOption: "UNAPPROVED_ACCOUNTS_ACCESS",
					},
					{
						name: strings?.pickupPoints,
						link: "/pickup-points",
						menuOption: "PICKUP_POINTS_ACCESS",
					},
					{
						name: strings?.subClient,
						link: "/subclient-accounts",
						menuOption: "SUBCLIENT_ACCOUNTS_ACCESS",
					},
				],
				type: "dropdown",
			},
			{
				name: strings?.bulkOperations,
				link: "/bulk-order-operations",
				icon: DatabaseOutlined as FunctionComponent,
				activeIcon: DatabaseOutlined as FunctionComponent,
				adminOnly: true,
			},
			{
				name: strings?.registerOrder,
				link: "/register-order",
				icon: isClient ? PlusIconWhite : PlusIcon,
				menuOption: "REGISTER_ORDER_ACCESS",
				type: "button",
			},
			{
				name: strings?.tickets,
				link: "showTiketatModal",
				icon: isClient ? PlusIconWhite : PlusIcon,
				menuOption: "PDF_TICKETS_ACCESS",
				type: "button",
			},
			{
				name: strings?.scan,
				link: "showSkanoModal",
				icon: isClient ? PlusIconWhite : PlusIcon,
				menuOption: "SCAN_ORDERS_ACCESS",
				type: "button",
			},
		];
		const filteredMenus = menus
			.filter(
				(m) =>
					m.type === "dropdown" ||
					(m.adminOnly
						? canAccessBulkOrderOperations()
						: menuOptions?.includes(m.menuOption as MenuAccess))
			)
			.map((m) => ({
				...m,
				disabled: m.adminOnly
					? false
					: !menuOptions?.includes(m.menuOption as MenuAccess),
				submenus: m.submenus?.filter(
					(s) => menuOptions?.includes(s.menuOption)
				),
			}));
		// .filter((m) => m.type !== "dropdown" || m.submenus?.length);
		setMenus(filteredMenus);

		return () => {
			if (interval) clearInterval(interval);
		};
	}, [isNotificationToggling, isToggling, menuOptions, strings, userRoleId]);

	const profileHeader: MenuProps["items"] = useMemo(
		() => [
			{
				key: "1",
				type: "group",
				label: (
					<div className="flex flex-col">
						<span className="profileNameAndSurname">
							{userData?.nameAndSurname}
						</span>
						<span>{userData?.email}</span>
					</div>
				),
				children: [
					{
						label: (
							<Link to="/my-account">
								<div className="profileIcons">
									<AccountProfile />
									{strings?.myProfile}
								</div>
							</Link>
						),
						key: "1-1",
					},
					{
						label: (
							<Link to="/my-account">
								<div className="profileIcons">
									<Notification />
									{strings?.notification}
								</div>
							</Link>
						),
						key: "1-2",
					},

					{
						label: (
							<Link to="/messages">
								<div className="profileIcons">
									{" "}
									<MessagesIcon />
									{strings?.messages}
								</div>
							</Link>
						),
						key: "1-3",
					},
					{
						label: (
							<div onClick={onClick} className="profileIcons">
								<ArrowLogout />
								<p>{strings?.logout}</p>
							</div>
						),
						key: "1-4",
					},
				],
			},
		],
		[onClick, userData?.email, userData?.nameAndSurname]
	);

	const onHeaderMenuButtonClick = (link: string) => {
		if (link === "showTiketatModal") {
			setShowTiketatModal(true);
		} else if (link === "showSkanoModal") {
			setShowSkanoModal(true);
		} else if (link === "/register-order") {
			navigate("register-order");
		}
		setMobileMenuOpen(false);
	};

	const handleMobileMenuToggle = () => {
		setMobileMenuOpen(!isMobileMenuOpen);
	};

	const handleClickLlogarit = (menuOption: any) => {
		setOpenMenus((prevOpenMenus: any) => ({
			...prevOpenMenus,
			[menuOption]: !prevOpenMenus[menuOption],
		}));
	};

	const handleClickOrders = () => {
		setOpenOrders(!openOrders);
	};

	const handleClose = () => {
		setShowTiketatModal(false);
		setShowSkanoModal(false);
		setOrderList([]);
	};

	const [orderIdInput, setOrderIdInput] = useState("");

	const handlePranoButtonClick = () => {
		navigate("order-details", { state: orderIdInput });
		setShowSkanoModal(false);
		setOrderIdInput("");
	};

	const handleVideoManualeButton = () => {
		navigate("/usage-manuals");
		handleMobileMenuToggle();
	};

	const cleanTicketInputAndClose = () => {
		setTicketOrderIds("");
		setShowTiketatModal(false);
	};
	const handleTicketPDF = async () => {
		if (!ticketOrderIds) {
			toast.warning("Ju lutem shtoni një barkod për printim.");
			return;
		}

		const isValidFormat = (id: any) =>
			/^[A-Z0-9]{2,}-\d{5,}$/.test(id.trim());

		const orderList = ticketOrderIds
			.split(",")
			.map((id) => id.trim())
			.filter((id) => isValidFormat(id))
			.map((id) => ({ id }));

		const params =
			selectedPrintFormat === "A4"
				? { formatA4: true }
				: selectedPrintFormat === "harleyTicket"
				? { harleyTicket: true }
				: {};

		if (orderList.length === 0) {
			toast.error(
				"Vendosni kodin e plote te Porosise, duke perfshire edhe kodin unifikues te biznesit."
			);
			return;
		}
		try {
			const response = await api.post(
				"Order/print-order-ticket-manually",
				orderList,
				{
					responseType: "blob",
					params,
				}
			);

			const invalidHeader =
				response.headers["x-invalid-ordercodes"] ??
				response.headers["X-Invalid-OrderCodes"];

			if (invalidHeader) {
				toast.warning(invalidHeader);
			}

			const file = response.data;
			const fileUrl = window.URL.createObjectURL(file);

			const pdfWindow = window.open();
			if (pdfWindow) {
				pdfWindow.location.href = fileUrl;
			} else {
				toast.error(
					"Popup është i bllokuar. Ju lutem lejoni popup për këtë faqe."
				);
			}
		} catch (error: any) {
			console.error(error);

			if (error?.response?.data instanceof Blob) {
				try {
					const text = await error.response.data.text();
					if (text) {
						toast.error(text); // message from backend
					} else {
						toast.error(
							"Ka ndodhur një gabim gjatë printimit të tiketave."
						);
					}
				} catch {
					toast.error(
						"Ka ndodhur një gabim gjatë leximit të përgjigjes."
					);
				}
			} else if (typeof error?.response?.data === "string") {
				toast.error(error.response.data);
			} else {
				toast.error(
					"Ka ndodhur një gabim gjatë printimit të tiketave."
				);
			}
		}
	};

	const playErrorSound = () => {
		const audio = new Audio(require("../assets/sounds/errorSound.mp3"));
		audio.play();
	};

	const [disableOrderScan, setDisableOrderScan] = useState<boolean>(false);

	const handleAcceptOrders = async () => {
		if (!orderIdInput) {
			return;
		}
		if (disableOrderScan) return;
		const removedPrefixInput = orderIdInput
			.toLocaleUpperCase()
			.replace("OR-", "");
		setDisableOrderScan(true);
		try {
			const url = hasAccessToAcceptLocalOrders
				? "Order/web-warehouse-local-order-accept"
				: "Order/web-warehouse-order-accept";
			const response = await api.post(url, null, {
				params: { orderId: removedPrefixInput },
			});
			if (response.status === 200) {
				if (response.data.data === 0) {
					playErrorSound();
					toast.warning(response.data.message);
				} else {
					toast.success(response.data.message);
				}
			}
			setOrderList([...orderList, { id: removedPrefixInput }]);
			setOrderIdInput("");
			//}
		} catch (error) {
			playErrorSound();
			console.error("Error fetching order status:", error);
			return null;
		} finally {
			setDisableOrderScan(false);
		}
	};

	const continueWarehouseWork = () => {
		setOrderIdInput("");
		setOpenWareHouseManagerErrorModal(false);
	};

	const [openMenus, setOpenMenus] = useState<any>({});

	const handleClick = (menuOption: any) => {
		setOpenMenus((prevOpenMenus: any) => ({
			...prevOpenMenus,
			[menuOption]: !prevOpenMenus[menuOption],
		}));
	};

	const [orderIDs, setOrderIDs] = useState([]);
	const [filteredOrders, setFilteredOrders] = useState([]);

	const fetchDataFromRedis = async () => {
		try {
			const response = await api.get("User/redis-search-bar-select");
			if (response.status === 200) {
				const users = response.data.users;
				const orders = response.data.orders;
				const settlements = response.data.settlements;
				const settlementRefusals = response.data.settlementRefusals;
				const excludedRolesForStaff = [
					userRoles.ADMIN,
					userRoles.CLIENT,
					userRoles.SUBCLIENT,
					userRoles.DRIVER,
				];
				const drivers = users?.filter(
					(item: UserSearchBarType) =>
						item.userRoleId === userRoles.DRIVER
				);
				const clients = users?.filter(
					(item: UserSearchBarType) =>
						item.userRoleId === userRoles.CLIENT
				);
				const staff = users?.filter(
					(item: UserSearchBarType) =>
						!excludedRolesForStaff.includes(item.userRoleId)
				);
				setClients(clients);
				setDrivers(drivers);
				setStaff(staff);
				setOrderIDs(orders);
				setSettlement(settlements);
				setSettlementRefusals(settlementRefusals);
			}
		} catch (error) {
			console.log(error);
		}
	};

	type SearchResult = {
		type: "order" | "client";
		displayId: string;
		id: number;
		description: string;
		statusColorHexCode?: string;
		statusDescription?: string;
	};

	const [filteredResults, setFilteredResults] = useState<SearchResult[]>([]);

	const handleSearchInputChange = (value: string) => {
		setSearchValue(value);

		if (userRoleId === userRoles.ADMIN) {
			const filteredOrders = value
				? orderIDs.filter((order: any) =>
						order.displayId
							.toLowerCase()
							.includes(value.toLowerCase())
				  )
				: [];
			const filteredClients = value
				? clients.filter((client: any) =>
						`${client.id} ${client.firstName} ${client.lastName} ${client.phone}`
							.toLowerCase()
							.includes(value.toLowerCase())
				  )
				: [];
			const filteredDrivers = value
				? drivers.filter((driver: any) =>
						`${driver.id} ${driver.firstName} ${driver.lastName}`
							.toLowerCase()
							.includes(value.toLowerCase())
				  )
				: [];
			const filteredStaff = value
				? staff.filter((staffMember: any) =>
						`${staffMember.id} ${staffMember.firstName} ${staffMember.lastName} ${staffMember.userRole}`
							.toLowerCase()
							.includes(value.toLowerCase())
				  )
				: [];
			const filteredSettlements = value
				? settlement.filter((settlementItem: any) =>
						`${settlementItem.id} ${settlementItem.settlementStatusDescription}`
							.toLowerCase()
							.includes(value.toLowerCase())
				  )
				: [];
			const filteredSettlementsRefusals = value
				? settlementRefusals.filter((settlementItem: any) =>
						`${settlementItem.id} ${settlementItem.settlementStatusDescription}`
							.toLowerCase()
							.includes(value.toLowerCase())
				  )
				: [];

			const combinedResults: any = [
				...filteredOrders.map((order: any) => ({
					type: "order",
					id: order.id,
					displayId: order.displayId,
					description: `#${order.displayId}`,
					statusColorHexCode: order.statusColorHexCode,
					statusDescription: order.statusDescription,
				})),
				...filteredClients.map((client: any) => ({
					type: "client",
					id: client.id,
					// description: `${strings?.client} #${client.id} `,
					// infos: `${client.firstName} ${client.lastName} (${client.phone})`,
					description: `${client.firstName} ${client.lastName} `,
					infos: `+${client.phone}`,
					role: strings?.client,
				})),
				...filteredDrivers.map((driver: any) => ({
					type: "driver",
					id: driver.id,
					// description: `${strings?.driver} #${driver.id} `,
					// infos: `${driver.firstName} ${driver.lastName}`,
					description: `${driver.firstName} ${driver.lastName} `,
					infos: `+${driver.phone}`,
					role: strings?.driver,
				})),
				...filteredStaff.map((staffMember: any) => ({
					type: "staff",
					id: staffMember.id,
					// description: `${strings?.staff} #${staffMember.id} `,
					description: `${staffMember.firstName} ${staffMember.lastName} `,
					// infos: `${staffMember.firstName} ${staffMember.lastName} (${staffMember.userRole})`,
					infos: `+${staffMember.phone}`,
					role: strings?.staff,
				})),
				...filteredSettlements.map((settlement: any) => ({
					type: "settlement",
					id: settlement.settlementId,
					description: `#${settlement.settlementId}`,
					statusColorHexCode: settlement.statusColorHexCode,
					statusDescription: settlement.settlementStatusDescription,
				})),
				...filteredSettlementsRefusals.map((settlement: any) => ({
					type: "settlementRefusals",
					id: settlement.settlementId,
					description: `#${settlement.settlementId}`,
					statusColorHexCode: settlement.statusColorHexCode,
					statusDescription: settlement.settlementStatusDescription,
				})),
			];
			setFilteredResults(combinedResults);
		} else if (userRoleId === userRoles.CLIENT) {
			const filteredOrders = value
				? orderIDs.filter((order: any) =>
						order.displayId
							.toLowerCase()
							.includes(value.toLowerCase())
				  )
				: [];
			const filteredSettlements = value
				? settlement.filter((settlementItem: any) =>
						`${settlementItem.settlementId} ${settlementItem.settlementStatusDescription}`
							.toLowerCase()
							.includes(value.toLowerCase())
				  )
				: [];
			const filteredSettlementsRefusals = value
				? settlementRefusals.filter((settlementItem: any) =>
						`${settlementItem.settlementId} ${settlementItem.settlementStatusDescription}`
							.toLowerCase()
							.includes(value.toLowerCase())
				  )
				: [];

			const combinedResults: any = [
				...filteredOrders.map((order: any) => ({
					type: "order",
					id: order.id,
					displayId: order.displayId,
					description: `#${order.displayId}`,
					statusColorHexCode: order.statusColorHexCode,
					statusDescription: order.statusDescription,
				})),

				...filteredSettlements.map((settlement: any) => ({
					type: "settlement",
					id: settlement.settlementId,
					description: `#${settlement.settlementId}`,
					statusColorHexCode: settlement.statusColorHexCode,
					statusDescription: settlement.settlementStatusDescription,
				})),
				...filteredSettlementsRefusals.map((settlement: any) => ({
					type: "settlementRefusals",
					id: settlement.settlementId,
					description: `#${settlement.settlementId}`,
					statusColorHexCode: settlement.statusColorHexCode,
					statusDescription: settlement.settlementStatusDescription,
				})),
			];
			setFilteredResults(combinedResults);
		}
	};

	const settlementDetailsPdf = async (settlementId: number) => {
		const ids = [{ id: settlementId }];

		try {
			const response = await api.post(
				"Settlement/print-settlement",
				ids,
				{
					responseType: "blob",
				}
			);
			const file = response.data;
			const fileUrl = window.URL.createObjectURL(file);

			const pdfWindow = window.open();
			if (pdfWindow) {
				pdfWindow.location.href = fileUrl;
			} else {
				console.error(
					"Popup blocked. Please allow popups for this site."
				);
			}
		} catch (error) {
			console.log(error);
		}
	};

	const handleOrderSelect = (value: any) => {
		const url = `/order-details?id=${value}`;
		window.open(url, "_blank");
	};

	const isSmallScreen = useMediaQuery("(max-width: 600px)");
	const isMediumScreen = useMediaQuery("(max-width: 768px)");
	const isLargeScreen = useMediaQuery("(max-width: 994px)");
	const isLargerScreen = useMediaQuery("(max-width: 1200px)");
	const newDrawerScreen = useMediaQuery("(max-width: 1800px)");

	const handleMenuClick = (menuOption: string, link?: string) => {
		if (link) {
			navigate(link);
		}
		setOpenMenus((prevOpenMenus: any) => ({
			...prevOpenMenus,
			[menuOption]: !prevOpenMenus[menuOption],
		}));
		handleMobileMenuToggle();
	};

	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
	const open = Boolean(anchorEl);

	const handleClick1 = (event: React.MouseEvent<HTMLElement>) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose1 = () => {
		setAnchorEl(null);
	};

	const [currentLanguage, setCurrentLanguage] = useState(
		localStorage.getItem("lang") || "al"
	);

	const renderLanguageIcon = () => {
		switch (currentLanguage) {
			case "al":
				return <AlbanianFlag width={40} />;
			case "en":
				return <EnglishFlag width={40} />;
			case "mk":
				return <MacedonianFlag width={40} />;
			default:
				return <LangugagesIcon width={40} />;
		}
	};

	const handleLanguageChange = (language: string) => {
		setCurrentLanguage(language);
		dispatch(setLanguage(language));
		setAnchorEl(null);
	};

	const handleNotificationClick = (item: NotificationType) => {
		setIsNotificationModalVisible(true);
		setSelectedNotification(item);
	};

	const handleNotificationCloseModal = async () => {
		try {
			if (!selectedNotification) return;

			let orderId: string | null = null;
			if (selectedNotification.title.includes("#")) {
				const match = selectedNotification.title.match(/#\S+/);
				if (match) {
					const orderReference = match[0];
					const parts = orderReference.split("-");
					if (parts.length === 2) {
						orderId = parts[1];
					}
				}
			}

			const result = await api.post(
				"Notification/open-notification",
				null,
				{ params: { id: selectedNotification.id } }
			);

			if (result.status === 200) {
				setIsNotificationModalVisible(false);
				await fetchNotificantions();

				if (orderId) {
					navigate(`/order-details?id=${orderId}`);
				}
			}
		} catch (error) {
			console.log(error);
		}
	};

	const clearNotifications = async () => {
		try {
			const result = await api.post("Notification/archive-notification");
			if (result.status === 200) {
				setNotifications([]);
				await fetchNotificantions();
			}
		} catch (error) {
			console.log(error);
		}
	};

	const handlePrintOrders = async () => {
		if (!orderList || orderList.length === 0) {
			toast.warning("Ju lutem shtoni një porosi për printim.");
			return;
		}

		const uniqueOrders = orderList.filter(
			(order, index, self) =>
				index === self.findIndex((o) => o.id === order.id)
		);

		const orderIds = uniqueOrders.map((order) => ({ id: order.id }));
		const params =
			selectedPrintFormat === "A4"
				? { formatA4: true }
				: selectedPrintFormat === "harleyTicket"
				? { harleyTicket: true }
				: {};
		try {
			const response = await api.post(
				"Order/print-order-ticket",
				orderIds,
				{
					responseType: "blob",
					params,
				}
			);

			const file = response.data;
			const fileUrl = window.URL.createObjectURL(file);

			const pdfWindow = window.open();
			if (pdfWindow) {
				pdfWindow.location.href = fileUrl;
			} else {
				toast.error(
					"Popup është i bllokuar. Ju lutem lejoni popup për këtë faqe."
				);
			}
		} catch (error) {
			console.error(error);
			toast.error(
				"Ka ndodhur një gabim gjatë printimit të listës së porosive."
			);
		}
	};
	return (
		<>
			{isLoggedIn ? (
				<>
					<div
						className="mainHeader"
						style={{
							backgroundColor: isClient ? "#F3F3F3" : "#4f16c2",
						}}
					>
						<div className="burgerDiv">
							{isClient ? (
								<BurgerMenuGray
									onClick={handleMobileMenuToggle}
									className="burgerMenu"
								/>
							) : (
								<BurgerMenu
									onClick={handleMobileMenuToggle}
									className="burgerMenu"
								/>
							)}
						</div>
						<SquareLoginLeft className="square" />
						<div className="mainHeader2">
							<div className="firstContainerHero">
								<div className="firstContainer">
									<Link
										to="/dashboard"
										className="headerLogoLink"
										aria-label="Dashboard"
									>
										{configurationId === 3 ? (
											<EuroKargo className="firstPostmanLogo" />
										) : isClient ? (
											<PostmanLogoClient className="firstPostmanLogo" />
										) : (
											<PostmanLogo className="firstPostmanLogo" />
										)}
									</Link>
									<div className="searchContainer">
										<div
											className="searchDiv"
											style={{
												backgroundColor: isClient
													? "#FFFFFF"
													: "#6a2ce7",
											}}
										>
											<SearchIcon width={15} />
										</div>
										<Autocomplete
											className="searchInput"
											style={{
												backgroundColor: isClient
													? "#FFFFFF"
													: "#6a2ce7",
												color: isClient
													? "black"
													: "white",
											}}
											sx={{
												"& .MuiOutlinedInput-notchedOutline":
													{
														border: "none",
													},
												"& .css-154xyx0-MuiInputBase-root-MuiOutlinedInput-root":
													{
														color: isClient
															? "black"
															: "white",
													},
											}}
											freeSolo
											options={filteredResults}
											value={searchValue}
											onChange={(
												event,
												newValue: any
											) => {
												if (newValue) {
													if (
														newValue.type ===
														"order"
													) {
														navigate(
															`/order-details?id=${newValue.id}`
														);
													} else if (
														newValue.type ===
														"client"
													) {
														navigate(
															`/client-details?id=${newValue.id}`
														);
													} else if (
														newValue.type ===
														"driver"
													) {
														navigate(
															`/driver-details?id=${newValue.id}`
														);
													} else if (
														newValue.type ===
														"settlement"
													) {
														settlementDetailsPdf(
															newValue.id
														);
													} else if (
														newValue.type ===
														"settlementRefusals"
													) {
														settlementDetailsPdf(
															newValue.id
														);
													}
													setSearchValue("");
													setFilteredResults([]);
												}
											}}
											onInputChange={(
												event,
												newInputValue
											) => {
												handleSearchInputChange(
													newInputValue
												);
											}}
											filterOptions={(
												options,
												params
											) => {
												return options.filter(
													(option) =>
														option.description
															.toLowerCase()
															.includes(
																params.inputValue.toLowerCase()
															) ||
														(option.infos &&
															option.infos
																.toLowerCase()
																.includes(
																	params.inputValue.toLowerCase()
																))
												);
											}}
											renderInput={(params) => (
												<TextField
													{...params}
													placeholder={
														strings?.search
													}
													variant="outlined"
													size="small"
												/>
											)}
											renderOption={(
												props,
												option: any
											) => (
												<li {...props}>
													<div className="flex gap-5 items-center justify-between w-full justify-between">
														{option.type ===
															"order" ||
														option.type ===
															"settlement" ||
														option.type ===
															"settlementRefusals" ? (
															<p className="text-xs text-blue-600 flex text-wrap ">
																{
																	option.description
																}
															</p>
														) : (
															<div className="flex flex-col">
																<p className="descriptionSearch">
																	{
																		option.description
																	}
																	<p className="roleDescription">
																		{
																			option.role
																		}
																	</p>
																</p>
															</div>
														)}
														{(option.type ===
															"order" ||
															option.type ===
																"settlement" ||
															option.type ===
																"settlementRefusals") &&
															option.statusDescription && (
																<div className="statusStyleSearchHeader">
																	<div
																		className="rounded-full flex justify-center h-8 items-center w-full gap-2 p-1.5"
																		style={{
																			backgroundColor:
																				hexToRgba(
																					option.statusColorHexCode ||
																						"#ffff",
																					0.08
																				),
																			color:
																				option.statusColorHexCode ||
																				"#ffff",
																		}}
																	>
																		<p className="text-xs">
																			&#x2022;
																		</p>
																		<p className="statusDescriptionSearch">
																			{
																				option.statusDescription
																			}
																		</p>
																	</div>
																</div>
															)}
														{option.type ===
															"client" && (
															<div className="clientInfo">
																<span className="clientName">
																	{
																		option.infos
																	}
																</span>
															</div>
														)}
														{option.type ===
															"driver" && (
															<div className="clientInfo">
																<span className="clientName">
																	{
																		option.infos
																	}
																</span>
															</div>
														)}
														{option.type ===
															"staff" && (
															<div className="clientInfo">
																<span className="clientName">
																	{
																		option.infos
																	}
																</span>
															</div>
														)}
													</div>
												</li>
											)}
										/>
									</div>

									<div className="notificationprofile">
										<div className="flex row w-auto">
											<div className="pl-4">
												{showNotificationDot ? (
													<p className="messageDot">
														⬤
													</p>
												) : (
													<></>
												)}
												<Dropdown
													overlay={
														<div className="scrollable-dropdown">
															<Menu
																items={
																	notifications
																}
																selectable={
																	true
																}
															/>
														</div>
													}
													className="test mr-2 "
													placement="bottom"
												>
													<button
														className="notif"
														style={{
															boxShadow:
																"0px 1px 2px 0px #0000001A",
															outline: "none",
															backgroundColor:
																isClient
																	? "#EDECF1"
																	: "",
														}}
														onClick={(e) => {
															e.preventDefault();
															dispatch(
																setReceivedNewNotification(
																	false
																)
															);
														}}
													>
														{isClient ? (
															<NotificationBlue />
														) : (
															<NotificationLogo />
														)}
													</button>
												</Dropdown>
											</div>

											<Link to="/messages">
												{showDot ? (
													<p className="messageDot">
														⬤
													</p>
												) : (
													<></>
												)}
												<p
													className="notification mr-2"
													style={{
														color: isClient
															? "#4F16C2"
															: "white",
														boxShadow:
															"0px 1px 2px 0px #0000001A",
														outline: "none",
														backgroundColor:
															isClient
																? "#EDECF1"
																: "",
													}}
												>
													{isClient ? (
														<MessageBlueIcon />
													) : (
														<MessageWhiteIcon />
													)}
												</p>
											</Link>
											<Link to="/usage-manuals">
												<p
													className="notification mr-2"
													style={{
														color: isClient
															? "#4F16C2"
															: "white",
														fontWeight: "bolder",
														boxShadow:
															"0px 1px 2px 0px #0000001A",
														outline: "none",
														backgroundColor:
															isClient
																? "#EDECF1"
																: "",
													}}
												>
													?
												</p>
											</Link>
											<div className="notificationLang ">
												<Tooltip
													title="Change Language"
													className="notificationLang "
													sx={{
														"&:focus": {
															outline: "none",
														},
														"&:hover": {
															backgroundColor:
																"none",
														},
													}}
												>
													<IconButton
														onClick={handleClick1}
													>
														{renderLanguageIcon()}
													</IconButton>
												</Tooltip>
												<MuiMenu
													anchorEl={anchorEl}
													open={open}
													onClose={handleClose1}
													anchorOrigin={{
														vertical: "bottom",
														horizontal: "center",
													}}
													transformOrigin={{
														vertical: "top",
														horizontal: "center",
													}}
													PaperProps={{
														sx: {
															mt: 0.2,
														},
													}}
												>
													<MenuItem
														onClick={() =>
															handleLanguageChange(
																"en"
															)
														}
													>
														<EnglishFlag
															width={30}
														/>
													</MenuItem>
													<MenuItem
														onClick={() =>
															handleLanguageChange(
																"al"
															)
														}
													>
														<AlbanianFlag
															width={30}
														/>
													</MenuItem>
													<MenuItem
														onClick={() =>
															handleLanguageChange(
																"mk"
															)
														}
													>
														<MacedonianFlag
															width={30}
														/>
													</MenuItem>
												</MuiMenu>
											</div>
										</div>
										<div className="dropdownProfile">
											<Dropdown
												menu={{
													items: profileHeader,
													selectable: true,
												}}
												className="test"
											>
												<button
													className={`ant-dropdown-link profileButton${
														isClient
															? ""
															: " isStaff"
													}`}
													title={
														userData?.nameAndSurname
													}
													onClick={(e) =>
														e.preventDefault()
													}
													style={{
														border: isClient
															? "none"
															: "1px solid white",
														boxShadow:
															"0px 1px 2px 0px #0000001A",
														color: isClient
															? "#4F16C2"
															: "white",
														outline: "none",
														backgroundColor:
															isClient
																? "#EDECF1"
																: "",
													}}
												>
													{nameInitials(
														userData?.nameAndSurname
													) ? (
														<span
															className="profileAvatar"
															aria-hidden="true"
														>
															{nameInitials(
																userData?.nameAndSurname
															)}
														</span>
													) : isClient ? (
														<ProfileLogoBlue />
													) : (
														<ProfileLogo />
													)}
													<span className="profileName">
														{
															userData?.nameAndSurname
														}
													</span>
													<span className="profileChevron">
														{isClient ? (
															<ArrowProfileBlue />
														) : (
															<ArrowProfile />
														)}
													</span>
												</button>
											</Dropdown>
										</div>
									</div>
								</div>
							</div>
							<div className="secondContainer">
								<div className="links">
									{menus.map((m: any, k: number) => {
										const isActive =
											location.pathname === m.link ||
											m.submenus?.some(
												(s: any) =>
													s.link === location.pathname
											);
										const IconComponent = isActive
											? m.activeIcon
											: m.icon;
										if (
											m.type === "dropdown" &&
											m.submenus?.length
										) {
											return (
												<div
													key={k}
													onClick={(e) => {
														if (m.disabled) return;
														if (
															location.pathname ===
															m.link
														) {
															window.location.reload();
														} else {
															navigate(m.link);
														}
													}}
													className={
														!m.disabled
															? "cursor-pointer"
															: "cursor-default"
													}
												>
													<Dropdown
														// to={m.link as string}
														// overlay={menu}
														menu={{
															items: m.submenus?.map(
																(
																	sm: any,
																	sk: number
																) => ({
																	label: (
																		<div
																			onClick={(
																				e
																			) => {
																				e.stopPropagation();
																				if (
																					location.pathname ===
																					sm.link
																				) {
																					window.location.reload();
																				} else {
																					navigate(
																						sm.link
																					);
																				}
																			}}
																		>
																			{
																				sm.name
																			}
																		</div>
																	),
																	key: sk,
																})
															),
														}}
														trigger={["hover"]}
														className={
															m.submenus?.some(
																(s: any) =>
																	s.link ===
																	location.pathname
															)
																? "active"
																: ""
														}
													>
														<p
															className={
																isActive
																	? isClient
																		? "link activeblue"
																		: "link active"
																	: isClient
																	? "linkClient"
																	: "link"
															}
														>
															<span className="icon">
																<IconComponent />
															</span>{" "}
															<div>{m.name}</div>
														</p>
													</Dropdown>
												</div>
											);
										} else if (m.type === "button") {
											return (
												<>
													<div className="buttonsDiv">
														<Button
															className={
																isClient
																	? "firstButtonHeaderClient"
																	: "firstButtonHeader"
															}
															onClick={() =>
																onHeaderMenuButtonClick(
																	m.link
																)
															}
														>
															<m.icon />
															{m.name}
														</Button>
													</div>
												</>
											);
										}
										return (
											<Link key={k} to={m.link as string}>
												<div
													className={
														isActive
															? isClient
																? "link activeblue"
																: "link active"
															: isClient
															? "linkClient"
															: "link"
													}
													// style={{
													// 	color: isClient
													// 		? "#818283"
													// 		: "#ffffff99",
													// }}
													onClick={(e) => {
														if (m.disabled) return;
														if (
															location.pathname ===
															m.link
														) {
															window.location.reload();
														} else {
															navigate(m.link);
														}
													}}
												>
													<span className="icon">
														<IconComponent />
													</span>{" "}
													<div>{m.name} </div>
												</div>
											</Link>
										);
									})}
								</div>
							</div>
						</div>
						<SquareLoginRight className="square" />
					</div>

					{isMobileMenuOpen && (
						<div className="mobileMenu">
							<Drawer
								open={isMobileMenuOpen}
								onClose={handleMobileMenuToggle}
								className="drawer"
								PaperProps={{
									sx: {
										backgroundColor: "#4f16c2",
										color: "blue",
										width: isSmallScreen
											? "60%"
											: isMediumScreen
											? "65%"
											: isLargeScreen
											? "50%"
											: isLargerScreen
											? "40%"
											: newDrawerScreen
											? "30%"
											: "65%",
										padding: "2rem",
										gap: "3rem",
										height: "100%",
										"& .drawerLinks": {
											display: "flex",
											flexDirection: "column",
											gap: "2rem",
											color: "white",
											fontSize: "large",
										},
										"& .css-16ac5r2-MuiButtonBase-root-MuiListItemButton-root":
											{
												minWidth: "10px",
												paddingLeft: 0,
												display: "flex",
												gap: "10px",
											},
										"& .css-10hburv-MuiTypography-root": {
											minWidth: "auto",
											fontSize: "large",
										},
										"& .css-cveggr-MuiListItemIcon-root": {
											minWidth: "10px",
											fontSize: "large",
										},
										"& .css-1f8bwsm": {
											minWidth: "29px",
										},
										"& .css-1uwabd6": {
											padding: "0",
										},
									},
								}}
							>
								<Link
									to="/dashboard"
									className="headerLogoLink"
									aria-label="Dashboard"
									onClick={handleMobileMenuToggle}
								>
									{configurationId === 3 ? (
										<EuroKargo className="secondPostmanLogo" />
									) : (
										<PostmanLogo className="secondPostmanLogo" />
									)}
								</Link>
								<div>
									<List className="drawerLinks">
										{menus.map(
											(menu: any, index: number) => {
												const isMenuOpen =
													openMenus[
														menu.menuOption
													] || false;

												if (
													menu.type === "dropdown" &&
													menu.submenus?.length
												) {
													return (
														<React.Fragment
															key={index}
														>
															<ListItemButton
																onClick={(
																	e
																) => {
																	if (
																		menu.name !==
																		"Llogarite"
																	) {
																		if (
																			location.pathname ===
																			menu.link
																		) {
																			window.location.reload();
																		} else {
																			navigate(
																				menu.link
																			);
																		}
																		handleMobileMenuToggle();
																	} else {
																		setOpenMenus(
																			(
																				prevOpenMenus: any
																			) => ({
																				...prevOpenMenus,
																				[menu.menuOption]:
																					!prevOpenMenus[
																						menu
																							.menuOption
																					],
																			})
																		);
																	}
																}}
															>
																<ListItemIcon>
																	<menu.icon />
																</ListItemIcon>
																<ListItemText
																	primary={
																		menu.name
																	}
																	sx={{
																		fontSize:
																			"x-large",
																	}}
																/>
																<ListItemIcon
																	onClick={(
																		e
																	) => {
																		e.stopPropagation();
																		setOpenMenus(
																			(
																				prevOpenMenus: any
																			) => ({
																				...prevOpenMenus,
																				[menu.menuOption]:
																					!prevOpenMenus[
																						menu
																							.menuOption
																					],
																			})
																		);
																	}}
																>
																	{isMenuOpen ? (
																		<ArrowProfile className="openIcon" />
																	) : (
																		<ArrowProfile className="closedIcon" />
																	)}
																</ListItemIcon>
															</ListItemButton>
															<Collapse
																in={isMenuOpen}
																timeout="auto"
																unmountOnExit
															>
																<List
																	disablePadding
																>
																	{menu.submenus.map(
																		(
																			submenu: any,
																			subIndex: number
																		) => (
																			<ListItemButton
																				key={
																					subIndex
																				}
																				sx={{
																					pl: 4,
																				}}
																				component={
																					Link
																				}
																				to={
																					submenu.link
																				}
																				onClick={(
																					e
																				) => {
																					e.stopPropagation();
																					if (
																						location.pathname ===
																						submenu.link
																					) {
																						window.location.reload();
																					} else {
																						navigate(
																							submenu.link
																						);
																					}
																					handleMobileMenuToggle();
																				}}
																			>
																				<ListItemText
																					primary={
																						submenu.name
																					}
																				/>
																			</ListItemButton>
																		)
																	)}
																</List>
															</Collapse>
														</React.Fragment>
													);
												} else if (
													menu.type === "button"
												) {
													return (
														<div
															key={index}
															className="mobileButtonsDiv"
														>
															<Button
																className="firstButtonHeader"
																onClick={() => {
																	onHeaderMenuButtonClick(
																		menu.link
																	);
																	handleMobileMenuToggle();
																}}
															>
																<menu.icon />
																{menu.name}
															</Button>
														</div>
													);
												}
												return (
													<Link
														key={index}
														to={menu.link as string}
														onClick={(e) => {
															if (
																location.pathname ===
																menu.link
															) {
																window.location.reload();
															} else {
																navigate(
																	menu.link
																);
															}
															handleMobileMenuToggle();
														}}
													>
														<div
															className={
																location.pathname ===
																menu.link
																	? "active"
																	: ""
															}
														>
															<div className="link">
																<menu.icon />{" "}
																<div>
																	{menu.name}
																</div>
															</div>
														</div>
													</Link>
												);
											}
										)}
										<div className="flex">
											<Tooltip
												title="Change Language"
												className="notificationLang "
												sx={{
													"&:focus": {
														outline: "none",
													},
													"&:hover": {
														backgroundColor: "none",
													},
												}}
											>
												<IconButton
													onClick={handleClick1}
												>
													{renderLanguageIcon()}
												</IconButton>
											</Tooltip>
											<MuiMenu
												anchorEl={anchorEl}
												open={open}
												onClose={handleClose1}
												anchorOrigin={{
													vertical: "bottom",
													horizontal: "center",
												}}
												transformOrigin={{
													vertical: "top",
													horizontal: "center",
												}}
												PaperProps={{
													sx: {
														mt: 0.2,
													},
												}}
											>
												<MenuItem
													onClick={() =>
														handleLanguageChange(
															"en"
														)
													}
												>
													<EnglishFlag width={30} />
												</MenuItem>
												<MenuItem
													onClick={() =>
														handleLanguageChange(
															"al"
														)
													}
												>
													<AlbanianFlag width={30} />
												</MenuItem>
												<MenuItem
													onClick={() =>
														handleLanguageChange(
															"mk"
														)
													}
												>
													<MacedonianFlag
														width={30}
													/>
												</MenuItem>
											</MuiMenu>
											<Tooltip
												title="Video Manuale"
												sx={{
													"&:focus": {
														outline: "none",
													},
													"&:hover": {
														backgroundColor: "none",
													},
												}}
											>
												<div
													className="notification border-1 border-white flex cursor-pointer ml-1"
													onClick={
														handleVideoManualeButton
													}
												>
													<span className="text-white">
														?
													</span>
												</div>
											</Tooltip>
										</div>
									</List>
								</div>
							</Drawer>
						</div>
					)}
				</>
			) : (
				<>
					<div
						className="mainHeader"
						style={{
							backgroundColor: "#4f16c2",
						}}
					>
						<div className="firstContainerLogin">
							<Link to="/main">
								{configurationId === 3 ? (
									<EuroKargo className="loginKargoLogo" />
								) : (
									<PostmanLogo className="loginPostmanLogo" />
								)}
							</Link>
							<div className="notificationprofile">
								<Tooltip
									title="Change Language"
									className="notificationLang "
									sx={{
										"&:focus": {
											outline: "none",
										},
										"&:hover": {
											backgroundColor: "none",
										},
									}}
								>
									<IconButton onClick={handleClick1}>
										{renderLanguageIcon()}
									</IconButton>
								</Tooltip>
								<MuiMenu
									anchorEl={anchorEl}
									open={open}
									onClose={handleClose1}
									anchorOrigin={{
										vertical: "bottom",
										horizontal: "center",
									}}
									transformOrigin={{
										vertical: "top",
										horizontal: "center",
									}}
									PaperProps={{
										sx: {
											mt: 0.2,
										},
									}}
								>
									<MenuItem
										onClick={() =>
											handleLanguageChange("en")
										}
									>
										<EnglishFlag width={30} />
									</MenuItem>
									<MenuItem
										onClick={() =>
											handleLanguageChange("al")
										}
									>
										<AlbanianFlag width={30} />
									</MenuItem>
									<MenuItem
										onClick={() =>
											handleLanguageChange("mk")
										}
									>
										<MacedonianFlag width={30} />
									</MenuItem>
								</MuiMenu>
								<div className="dropdownProfile">
									<div className="test">
										<button
											className="ant-dropdown-link"
											style={{
												border: "1px solid white",
												color: "white",
												outline: "none",
											}}
											onClick={(e) => e.preventDefault()}
										>
											<Link to={"/login"}>
												<div className="profileLogosLogin">
													{strings?.login}
													<ProfileLogo />
												</div>
											</Link>
										</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</>
			)}
			<Modal
				open={showTiketatModal}
				onCancel={cleanTicketInputAndClose}
				centered
				footer={null}
			>
				<div className="skanoContainer">
					<h1 className="profileNameAndSurname">
						Printo tiketat e porosive
					</h1>

					<div className="inputButton">
						<Input
							placeholder="Sheno barkodinkodin e porosise..."
							className="defaultInput"
							value={ticketOrderIds}
							onChange={(e: any) =>
								setTicketOrderIds(e.target.value)
							}
						/>
						<Button
							className="buttonSkano"
							onClick={() => {
								setActivePrintFunction("tickets");
								setIsPrintFormatModalOpen(true);
							}}
						>
							Skano
						</Button>
					</div>
				</div>
			</Modal>
			<Modal
				open={showSkanoModal}
				onCancel={handleClose}
				centered
				footer={null}
				width={800}
			>
				<div className="skanoContainer">
					<h1 className="border-b-2">Prano porositë në sistem</h1>
					<p>
						Pranimi i porosise permes kesaj metode do ta ndryshoj
						statusin e porosise ne sistem sipas tabeles me poshte
					</p>
					{/* <div className="scanInfo">
						<p>Per grumbillim</p>
						<p> ={">"} </p>
						<p>Pranuar nga posta </p>
					</div> */}
					<div className="scanInfo">
						<p>Ne transport</p>
						<p> ={">"} </p>
						<p>Ne depo </p>
					</div>
					<div className="scanInfo">
						<p>Ne pritje</p>
						<p> ={">"} </p>
						<p>Ne depo </p>
					</div>
					<p>
						Porosite qe kan status: Pranuar nga posta, ne depo, ne
						depon per kthim do te pranohen ne llogarine tuaj pa
						ndryshim statusi.
					</p>
					<div className="border" />
					<div className="inputButton">
						<Input
							placeholder="Skano kodin e porosise..."
							className="defaultInput"
							value={orderIdInput}
							onChange={(e: any) =>
								setOrderIdInput(e.target.value)
							}
							onPressEnter={handleAcceptOrders}
						/>
						<Button
							className="buttonSkano"
							onClick={handleAcceptOrders}
						>
							Prano
						</Button>
						<div className="buttonPrintoContainer">
							<Button
								className="buttonPrinto"
								onClick={() => {
									if (!orderList || orderList.length === 0) {
										toast.error(
											"Nuk ka asnjë porosi të zgjedhur për printim"
										);
										return;
									}
									setActivePrintFunction("orders");
									setIsPrintFormatModalOpen(true);
								}}
							>
								PRINTO
							</Button>
						</div>
					</div>

					<div className="flex flex-wrap gap-6">
						{orderList.map((item: any, idx: number) => (
							<div
								key={idx}
								className="flex flex-wrap"
								style={{
									fontSize: 18,
								}}
							>
								<p onClick={(e) => handleOrderSelect(item.id)}>
									#{item.id}
								</p>
							</div>
						))}
					</div>
				</div>
			</Modal>
			<Modal
				open={openWareHouseManagerErrorModal}
				onCancel={() => setOpenWareHouseManagerErrorModal(false)}
				title={"Error"}
				footer={(_: any, { CancelBtn }: any) => (
					<>
						<div className="flex items-center justify-center">
							<Button
								type="primary"
								size="large"
								style={{ backgroundColor: "#4F16C2" }}
								onClick={continueWarehouseWork}
							>
								Ne rregull
							</Button>
							<CancelBtn />
						</div>
					</>
				)}
				centered
			>
				<p>{warehouseErrorString}</p>
			</Modal>
			<Modal
				title="Detajet e Njoftimit"
				open={isNotificationModalVisible}
				onCancel={handleNotificationCloseModal}
				onOk={handleNotificationCloseModal}
				okButtonProps={{ style: { backgroundColor: "#4F16C2" } }}
				okText={"Në rregull"}
				cancelText={"Mbyll"}
			>
				<p className="font-bold">{selectedNotification?.title}</p>
				<p>{selectedNotification?.body}</p>
			</Modal>
			<Modal
				title="Zgjidh Formatin e Printimit"
				open={isPrintFormatModalOpen}
				onOk={() => {
					setIsPrintFormatModalOpen(false);
					handleTicketPDF();
				}}
				onCancel={() => setIsPrintFormatModalOpen(false)}
				style={{
					zIndex: 2000,
				}}
				footer={
					<Buttons
						button1Text="Anulo"
						button2Text="Printo"
						onButton1Click={() => setIsPrintFormatModalOpen(false)}
						onButton2Click={() => {
							setIsPrintFormatModalOpen(false);
							if (activePrintFunction === "tickets") {
								handleTicketPDF();
							} else if (activePrintFunction === "orders") {
								handlePrintOrders();
							}
						}}
					/>
				}
			>
				<Radio.Group
					value={selectedPrintFormat}
					onChange={(e) => setSelectedPrintFormat(e.target.value)}
				>
					<Radio value="100x60">100x60</Radio>

					{hasAccessToA4 && <Radio value="A4">A4</Radio>}
					{hasAccessToHarleyTickets && (
						<Radio value="harleyTicket">Harley tiket</Radio>
					)}
				</Radio.Group>
			</Modal>
		</>
	);
};

export default Header;
